import { TrendingUp } from '@mui/icons-material'
import { Appliance, ApplianceConfigEnergyMeter } from './Appliance'
import { getWidget } from '../widgets'
import { ConsumptionStatWidget } from '../widgets/ComsumptionStatWidget'
import { PowerGraphWidget } from '../widgets/PowerGraph'

export class EnergyMeterAppliance extends Appliance<{}, ApplianceConfigEnergyMeter> {

  get Icon() {
    return TrendingUp
  }

  getSubtypes(): Record<string, string> {
    return {
      [this.app.t('Current Transformer')]: 'EM_3PH',
      [this.app.t('HAN Reader')]: 'EM_HAN',
      [this.app.t('Led Reader')]: 'EM_SIMPLE',
      [this.app.t('Virtual net sum')]: 'EM_NETSUM',
    }
  }

  getDefaultWidgets(): [ConsumptionStatWidget, PowerGraphWidget] {
    return [
      getWidget({
        name: '',
        type: 'COMSUMPTION_STAT',
        appliances: [this],
        config: {}
      }, this.control, this.app) as ConsumptionStatWidget,
      getWidget({
        name: '',
        type: 'POWER_GRAPH',
        appliances: [this],
        config: {}
      }, this.control, this.app) as PowerGraphWidget,
    ]
  }

  alwaysTestPage() {
    return this.getControl(0).port.type === 'EM_3PH'
  }

  /**
   * The EM_3PH "Continue" leads to the live data / calibration page; going
   * there must not reboot the device unless the settings really changed.
   */
  flashOnlyWhenNeeded() {
    return this.getControl(0).port.type === 'EM_3PH'
  }

}
